import { Button, Col, Form, Input, Row, Select, Space } from 'antd'
import useHook, { ExpressItem } from './hooks'
import CustomModal from '../../../../components/ModalUser'
import TableAntd from '../../../../components/TableAntd'
import styles from './style.module.scss'
import {
  DELIVERY_PHONE_HINT,
  isPhoneDeliveryLogistics,
} from '../../../../utils/deliveryLogistics'
import { regexDict } from '../../../../tools/regex'
import { useThumbnailRenderHook } from '../..'

// 下拉搜索关键字高亮
export const LightHeightOption = (props: any) => {
  const { filterTxt, text } = props
  const heightLightTxt = (txt: string, heightTxt: string) => {
    if (heightTxt === '') {
      return txt
    }
    // 前面filterOption 不区分大小写，这里用i
    const regexp = new RegExp(heightTxt, 'gi')
    return txt.replace(regexp, '<span style="color:red">$&</span>')
  }
  return (
    <div
      ref={(nodeElement) => {
        if (nodeElement) {
          nodeElement.innerHTML = heightLightTxt(text, filterTxt)
        }
      }}
    />
  )
}
function getExpressKey(expressItem: ExpressItem) {
  return `${expressItem?.code ?? ''}${expressItem?.expressCompany ?? ''}`
}
export default function AddDeliveryOrder() {
  const {
    currentPageState,
    expressSelectList,
    form,
    formModal,
    isChangeDeliveryInfoModalVisible,
    isTableLoading,
    isDetail,
    expressSearchValue,
    submitBtnLoading,
    handleChangeDeliveryInfoClick,
    handleChangeDeliveryInfoCancel,
    handleDeleteRow,
    handleDeliveryInfoSave,
    handleSubmit,
    handleTableChangeCheck,
    onExpressSearch,
    onExpressSelect,
    handleClosePage,
  } = useHook()
  const { thumbnailRender } = useThumbnailRenderHook()
  const formItemLayout = {
    wrapperCol: { span: 12 },
  }
  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const delCountRender = (text: any, record: any) => {
    if (isDetail) {
      return text
    }

    return (
      <Form.Item
        className={styles['table-form-item']}
        name={record.id + 'delCount'}
        rules={[
          {
            validator: function (rule: any, value: string) {
              if (!value) {
                return Promise.reject(new Error('发货数量必填'))
              }
              if (
                !/^[0-9]+\d{0,9}(\.\d{1,10})?$/.test(value) ||
                Number(value) === 0
              ) {
                return Promise.reject(new Error('必须是大于0且最多十位小数'))
              }
              if (parseInt(value) > parseInt(record.unCount)) {
                return Promise.reject(new Error('大于未发数量'))
              }
              return Promise.resolve()
            },
          },
        ]}
        initialValue={record.unCount}
      >
        <Input placeholder="请输入"></Input>
      </Form.Item>
    )
  }
  const listColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: orderNoRender,
    },
    {
      key: 'imgUrl',
      dataIndex: 'imgUrl',
      title: '商品图',
      render: thumbnailRender,
    },
    {
      key: 'code',
      dataIndex: 'code',
      title: '物料编码',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '商品名称',
    },
    {
      key: 'model',
      dataIndex: 'model',
      title: '型号',
    },
    {
      key: 'num',
      dataIndex: 'num',
      title: '数量',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '单价',
    },
    {
      key: 'unCount',
      dataIndex: 'unCount',
      title: '未发数量',
    },
    {
      key: 'delCount',
      dataIndex: 'delCount',
      title: '本次发货数量',
      render: delCountRender,
    },
  ]
  return (
    <div className={styles['inner-content']}>
      <div className={styles['order-info']}>
        <div className={styles['header']}>
          <Space>
            <span>客户订单号：{currentPageState?.orderNo}</span>
          </Space>
        </div>
        <Row className={styles['content']}>
          <Col span={8}>
            <div className={styles['info-text-container']}>
              客户名称：{currentPageState?.customer}
            </div>
            <div className={styles['info-text-container']}>
              收货地址：{currentPageState?.address}
            </div>
          </Col>
          <Col span={8}>
            <div className={styles['info-text-container']}>
              收件人：{currentPageState?.consignee}
            </div>
          </Col>
          <Col span={8}>
            <div className={styles['info-text-container']}>
              联系方式：{currentPageState?.mobile}
            </div>
          </Col>
        </Row>
      </div>
      <div className={styles['table-container']}>
        <div className={styles['form-container']}>
          <Form {...formItemLayout} form={form}>
            <Row justify="space-between" className={styles['header']}>
              <span className={styles['title']}>发货物料明细</span>
              <Button onClick={handleDeleteRow}>删除行</Button>
            </Row>
            <TableAntd
              dataSource={
                isDetail
                  ? currentPageState?.deliveryProductList
                  : currentPageState?.selectedProductList
              }
              listColumn={
                isDetail
                  ? listColumn.filter((item) => {
                      return item.key !== 'unCount'
                    })
                  : listColumn
              }
              loading={isTableLoading}
              onChangeCheck={isDetail ? undefined : handleTableChangeCheck}
              selfAdaptScroll
            ></TableAntd>
            <Row className={styles['delivery-info']}>
              <div className={styles['title']}>物流信息</div>
            </Row>
            <Row>
              <Col span={12}>
                <Row>
                  <Form.Item
                    className={styles['form-item']}
                    name="expressCompany"
                    label="物流公司"
                    rules={[
                      {
                        required: true,
                        message: '物流公司必选',
                      },
                    ]}
                  >
                    <Select
                      placeholder="请选择"
                      disabled={isDetail ? true : false}
                      allowClear
                      showSearch
                      onSearch={onExpressSearch}
                      onSelect={onExpressSelect}
                      filterOption={(input, option: any) =>
                        (option.children &&
                          option.children.props &&
                          option.children.props.text &&
                          option.children.props.text
                            .toLowerCase()
                            .indexOf(input.toLowerCase())) >= 0
                      }
                      onChange={() =>
                        form.setFields([{ name: 'expressNo', errors: [] }])
                      }
                    >
                      {expressSelectList?.map((item) => {
                        return (
                          <Select.Option
                            key={getExpressKey(item)}
                            value={item.expressCompany}
                          >
                            <LightHeightOption
                              text={item.expressCompany}
                              filterTxt={expressSearchValue}
                            ></LightHeightOption>
                          </Select.Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                      const expressCompany = getFieldValue('expressCompany')
                      const selectedExpress = expressSelectList.find(
                        (item) => item.expressCompany === expressCompany,
                      )
                      const requiresPhone =
                        isPhoneDeliveryLogistics(selectedExpress)
                      return expressCompany === '厂家直发' ? (
                        <Form.Item
                          className={styles['form-item']}
                          label="送货人手机号"
                          name="expressNo"
                          required
                          rules={[
                            {
                              required: true,
                              message: '请输入',
                            },
                            {
                              ...regexDict.mobileSymbol,
                            },
                          ]}
                        >
                          <Input maxLength={30}></Input>
                        </Form.Item>
                      ) : (
                        <Form.Item
                          className={styles['form-item']}
                          name="expressNo"
                          label="物流单号"
                          extra={DELIVERY_PHONE_HINT}
                          validateTrigger={
                            requiresPhone ? ['onChange', 'onBlur'] : undefined
                          }
                          rules={
                            requiresPhone
                              ? [
                                  {
                                    required: true,
                                    pattern: /^1[3-9]\d{9}$/,
                                    message: '请输入正确的11位手机号',
                                  },
                                ]
                              : [
                                  {
                                    type: 'string',
                                    required: true,
                                    whitespace: true,
                                    validator: function (
                                      rule: any,
                                      value: string,
                                    ) {
                                      if (!value) {
                                        return Promise.reject(
                                          new Error('物流单号未填写'),
                                        )
                                      }
                                      if (
                                        value.replace(/[0-9a-zA-Z\/]/g, '')
                                          .length > 0
                                      ) {
                                        return Promise.reject(
                                          new Error(
                                            '只支持输入字母、数字、反斜杠"/"',
                                          ),
                                        )
                                      }
                                      return Promise.resolve()
                                    },
                                  },
                                ]
                          }
                        >
                          <Input
                            placeholder="请输入"
                            disabled={isDetail ? true : false}
                            maxLength={60}
                          ></Input>
                        </Form.Item>
                      )
                    }}
                  </Form.Item>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
        <div className={styles['bottom-buttons-container']}>
          <Space>
            <div>
              <Button onClick={handleClosePage}>取消</Button>
            </div>
            {!isDetail ? (
              <Button
                type="primary"
                onClick={handleSubmit}
                className={styles['button-item']}
                loading={submitBtnLoading}
              >
                提交
              </Button>
            ) : (
              <Button onClick={handleChangeDeliveryInfoClick}>
                变更物流信息
              </Button>
            )}
          </Space>
        </div>
        <CustomModal
          title="变更物流信息"
          footer={
            <Row justify="center">
              <Button
                onClick={handleDeliveryInfoSave}
                loading={submitBtnLoading}
              >
                保存
              </Button>
            </Row>
          }
          modalCancel={handleChangeDeliveryInfoCancel}
          open={isChangeDeliveryInfoModalVisible}
        >
          <Form form={formModal} className={styles.formStyle}>
            <Form.Item
              className={styles['form-item']}
              name="expressCompany"
              label="物流公司"
              rules={[
                {
                  required: true,
                  message: '物流公司必选',
                },
              ]}
            >
              <Select
                placeholder="请选择"
                allowClear
                showSearch
                onSearch={onExpressSearch}
                onSelect={onExpressSelect}
                filterOption={(input, option: any) =>
                  (option.children &&
                    option.children.props &&
                    option.children.props.text &&
                    option.children.props.text
                      .toLowerCase()
                      .indexOf(input.toLowerCase())) >= 0
                }
                getPopupContainer={() => document.body}
                onChange={() => formModal.validateFields(['expressNo'])}
              >
                {expressSelectList?.map((item) => {
                  return (
                    <Select.Option
                      key={getExpressKey(item)}
                      value={item.expressCode}
                    >
                      <LightHeightOption
                        text={item.expressCompany}
                        filterTxt={expressSearchValue}
                      ></LightHeightOption>
                    </Select.Option>
                  )
                })}
              </Select>
            </Form.Item>
            <Form.Item
              className={styles['form-item']}
              name="expressNo"
              label="物流单号"
              rules={[
                ({ getFieldValue }) => ({
                  type: 'string',
                  required: getFieldValue('expressCompany') !== 'XHZYWL',
                  whitespace: getFieldValue('expressCompany') !== 'XHZYWL',
                  validator: function (rule: any, value: string) {
                    if (!value) {
                      return Promise.reject(new Error('物流单号未填写'))
                    }
                    if (value.replace(/[0-9a-zA-Z\/]/g, '').length > 0) {
                      return Promise.reject(
                        new Error('只支持输入字母、数字、反斜杠"/"'),
                      )
                    }
                    return Promise.resolve()
                  },
                }),
              ]}
            >
              <Input placeholder="请输入" maxLength={60}></Input>
            </Form.Item>
          </Form>
          <Row
            justify="center"
            style={{
              color: 'red',
            }}
          >
            变更后的物流信息可能第三方平台无法更新
          </Row>
        </CustomModal>
      </div>
    </div>
  )
}
import { Button, Col, Form, Input, Row, Select, Space } from 'antd'
import useHook, { ExpressItem } from './hooks'
import CustomModal from '../../../../components/ModalUser'
import TableAntd from '../../../../components/TableAntd'
import styles from './style.module.scss'
import {
  DELIVERY_PHONE_HINT,
  isPhoneDeliveryLogistics,
} from '../../../../utils/deliveryLogistics'
import { regexDict } from '../../../../tools/regex'
import { useThumbnailRenderHook } from '../..'

// 下拉搜索关键字高亮
export const LightHeightOption = (props: any) => {
  const { filterTxt, text } = props
  const heightLightTxt = (txt: string, heightTxt: string) => {
    if (heightTxt === '') {
      return txt
    }
    // 前面filterOption 不区分大小写，这里用i
    const regexp = new RegExp(heightTxt, 'gi')
    return txt.replace(regexp, '<span style="color:red">$&</span>')
  }
  return (
    <div
      ref={(nodeElement) => {
        if (nodeElement) {
          nodeElement.innerHTML = heightLightTxt(text, filterTxt)
        }
      }}
    />
  )
}
function getExpressKey(expressItem: ExpressItem) {
  return `${expressItem?.code ?? ''}${expressItem?.expressCompany ?? ''}`
}
export default function AddDeliveryOrder() {
  const {
    currentPageState,
    expressSelectList,
    form,
    formModal,
    isChangeDeliveryInfoModalVisible,
    isTableLoading,
    isDetail,
    expressSearchValue,
    submitBtnLoading,
    handleChangeDeliveryInfoClick,
    handleChangeDeliveryInfoCancel,
    handleDeleteRow,
    handleDeliveryInfoSave,
    handleSubmit,
    handleTableChangeCheck,
    onExpressSearch,
    onExpressSelect,
    handleClosePage,
  } = useHook()
  const { thumbnailRender } = useThumbnailRenderHook()
  const formItemLayout = {
    wrapperCol: { span: 12 },
  }
  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }
  const delCountRender = (text: any, record: any) => {
    if (isDetail) {
      return text
    }

    return (
      <Form.Item
        className={styles['table-form-item']}
        name={record.id + 'delCount'}
        rules={[
          {
            validator: function (rule: any, value: string) {
              if (!value) {
                return Promise.reject(new Error('发货数量必填'))
              }
              if (
                !/^[0-9]+\d{0,9}(\.\d{1,10})?$/.test(value) ||
                Number(value) === 0
              ) {
                return Promise.reject(new Error('必须是大于0且最多十位小数'))
              }
              if (parseInt(value) > parseInt(record.unCount)) {
                return Promise.reject(new Error('大于未发数量'))
              }
              return Promise.resolve()
            },
          },
        ]}
        initialValue={record.unCount}
      >
        <Input placeholder="请输入"></Input>
      </Form.Item>
    )
  }
  const listColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: orderNoRender,
    },
    {
      key: 'imgUrl',
      dataIndex: 'imgUrl',
      title: '商品图',
      render: thumbnailRender,
    },
    {
      key: 'code',
      dataIndex: 'code',
      title: '物料编码',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '商品名称',
    },
    {
      key: 'model',
      dataIndex: 'model',
      title: '型号',
    },
    {
      key: 'num',
      dataIndex: 'num',
      title: '数量',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '单价',
    },
    {
      key: 'unCount',
      dataIndex: 'unCount',
      title: '未发数量',
    },
    {
      key: 'delCount',
      dataIndex: 'delCount',
      title: '本次发货数量',
      render: delCountRender,
    },
  ]
  return (
    <div className={styles['inner-content']}>
      <div className={styles['order-info']}>
        <div className={styles['header']}>
          <Space>
            <span>客户订单号：{currentPageState?.orderNo}</span>
          </Space>
        </div>
        <Row className={styles['content']}>
          <Col span={8}>
            <div className={styles['info-text-container']}>
              客户名称：{currentPageState?.customer}
            </div>
            <div className={styles['info-text-container']}>
              收货地址：{currentPageState?.address}
            </div>
          </Col>
          <Col span={8}>
            <div className={styles['info-text-container']}>
              收件人：{currentPageState?.consignee}
            </div>
          </Col>
          <Col span={8}>
            <div className={styles['info-text-container']}>
              联系方式：{currentPageState?.mobile}
            </div>
          </Col>
        </Row>
      </div>
      <div className={styles['table-container']}>
        <div className={styles['form-container']}>
          <Form {...formItemLayout} form={form}>
            <Row justify="space-between" className={styles['header']}>
              <span className={styles['title']}>发货物料明细</span>
              <Button onClick={handleDeleteRow}>删除行</Button>
            </Row>
            <TableAntd
              dataSource={
                isDetail
                  ? currentPageState?.deliveryProductList
                  : currentPageState?.selectedProductList
              }
              listColumn={
                isDetail
                  ? listColumn.filter((item) => {
                      return item.key !== 'unCount'
                    })
                  : listColumn
              }
              loading={isTableLoading}
              onChangeCheck={isDetail ? undefined : handleTableChangeCheck}
              selfAdaptScroll
            ></TableAntd>
            <Row className={styles['delivery-info']}>
              <div className={styles['title']}>物流信息</div>
            </Row>
            <Row>
              <Col span={12}>
                <Row>
                  <Form.Item
                    className={styles['form-item']}
                    name="expressCompany"
                    label="物流公司"
                    rules={[
                      {
                        required: true,
                        message: '物流公司必选',
                      },
                    ]}
                  >
                    <Select
                      placeholder="请选择"
                      disabled={isDetail ? true : false}
                      allowClear
                      showSearch
                      onSearch={onExpressSearch}
                      onSelect={onExpressSelect}
                      filterOption={(input, option: any) =>
                        (option.children &&
                          option.children.props &&
                          option.children.props.text &&
                          option.children.props.text
                            .toLowerCase()
                            .indexOf(input.toLowerCase())) >= 0
                      }
                      onChange={() =>
                        form.setFields([{ name: 'expressNo', errors: [] }])
                      }
                    >
                      {expressSelectList?.map((item) => {
                        return (
                          <Select.Option
                            key={getExpressKey(item)}
                            value={item.expressCompany}
                          >
                            <LightHeightOption
                              text={item.expressCompany}
                              filterTxt={expressSearchValue}
                            ></LightHeightOption>
                          </Select.Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                </Row>
                <Row>
                  <Form.Item noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                      const expressCompany = getFieldValue('expressCompany')
                      const selectedExpress = expressSelectList.find(
                        (item) => item.expressCompany === expressCompany,
                      )
                      const requiresPhone =
                        isPhoneDeliveryLogistics(selectedExpress)
                      return expressCompany === '厂家直发' ? (
                        <Form.Item
                          className={styles['form-item']}
                          label="送货人手机号"
                          name="expressNo"
                          required
                          rules={[
                            {
                              required: true,
                              message: '请输入',
                            },
                            {
                              ...regexDict.mobileSymbol,
                            },
                          ]}
                        >
                          <Input maxLength={30}></Input>
                        </Form.Item>
                      ) : (
                        <Form.Item
                          className={styles['form-item']}
                          name="expressNo"
                          label="物流单号"
                          extra={DELIVERY_PHONE_HINT}
                          validateTrigger={
                            requiresPhone ? ['onChange', 'onBlur'] : undefined
                          }
                          rules={
                            requiresPhone
                              ? [
                                  {
                                    required: true,
                                    pattern: /^1[3-9]\d{9}$/,
                                    message: '请输入正确的11位手机号',
                                  },
                                ]
                              : [
                                  {
                                    type: 'string',
                                    required: true,
                                    whitespace: true,
                                    validator: function (
                                      rule: any,
                                      value: string,
                                    ) {
                                      if (!value) {
                                        return Promise.reject(
                                          new Error('物流单号未填写'),
                                        )
                                      }
                                      if (
                                        value.replace(/[0-9a-zA-Z\/]/g, '')
                                          .length > 0
                                      ) {
                                        return Promise.reject(
                                          new Error(
                                            '只支持输入字母、数字、反斜杠"/"',
                                          ),
                                        )
                                      }
                                      return Promise.resolve()
                                    },
                                  },
                                ]
                          }
                        >
                          <Input
                            placeholder="请输入"
                            disabled={isDetail ? true : false}
                            maxLength={60}
                          ></Input>
                        </Form.Item>
                      )
                    }}
                  </Form.Item>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
        <div className={styles['bottom-buttons-container']}>
          <Space>
            <div>
              <Button onClick={handleClosePage}>取消</Button>
            </div>
            {!isDetail ? (
              <Button
                type="primary"
                onClick={handleSubmit}
                className={styles['button-item']}
                loading={submitBtnLoading}
              >
                提交
              </Button>
            ) : (
              <Button onClick={handleChangeDeliveryInfoClick}>
                变更物流信息
              </Button>
            )}
          </Space>
        </div>
        <CustomModal
          title="变更物流信息"
          footer={
            <Row justify="center">
              <Button
                onClick={handleDeliveryInfoSave}
                loading={submitBtnLoading}
              >
                保存
              </Button>
            </Row>
          }
          modalCancel={handleChangeDeliveryInfoCancel}
          open={isChangeDeliveryInfoModalVisible}
        >
          <Form form={formModal} className={styles.formStyle}>
            <Form.Item
              className={styles['form-item']}
              name="expressCompany"
              label="物流公司"
              rules={[
                {
                  required: true,
                  message: '物流公司必选',
                },
              ]}
            >
              <Select
                placeholder="请选择"
                allowClear
                showSearch
                onSearch={onExpressSearch}
                onSelect={onExpressSelect}
                filterOption={(input, option: any) =>
                  (option.children &&
                    option.children.props &&
                    option.children.props.text &&
                    option.children.props.text
                      .toLowerCase()
                      .indexOf(input.toLowerCase())) >= 0
                }
                getPopupContainer={() => document.body}
                onChange={() => formModal.validateFields(['expressNo'])}
              >
                {expressSelectList?.map((item) => {
                  return (
                    <Select.Option
                      key={getExpressKey(item)}
                      value={item.expressCode}
                    >
                      <LightHeightOption
                        text={item.expressCompany}
                        filterTxt={expressSearchValue}
                      ></LightHeightOption>
                    </Select.Option>
                  )
                })}
              </Select>
            </Form.Item>
            <Form.Item
              className={styles['form-item']}
              name="expressNo"
              label="物流单号"
              rules={[
                ({ getFieldValue }) => ({
                  type: 'string',
                  required: getFieldValue('expressCompany') !== 'XHZYWL',
                  whitespace: getFieldValue('expressCompany') !== 'XHZYWL',
                  validator: function (rule: any, value: string) {
                    if (!value) {
                      return Promise.reject(new Error('物流单号未填写'))
                    }
                    if (value.replace(/[0-9a-zA-Z\/]/g, '').length > 0) {
                      return Promise.reject(
                        new Error('只支持输入字母、数字、反斜杠"/"'),
                      )
                    }
                    return Promise.resolve()
                  },
                }),
              ]}
            >
              <Input placeholder="请输入" maxLength={60}></Input>
            </Form.Item>
          </Form>
          <Row
            justify="center"
            style={{
              color: 'red',
            }}
          >
            变更后的物流信息可能第三方平台无法更新
          </Row>
        </CustomModal>
      </div>
    </div>
  )
}
